<div class="dialog-container step-pagination">
  <button class="close-btn" mat-icon-button (click)="close()">✕</button>

  <ng-container [ngSwitch]="step">
    <app-add-candidat-step
      *ngSwitchCase="1"
      [form]="fourthStepForm"
      [loading]="loading"
      (onValidated)="onFourthStepValid($event)"
      (nextStepEmitter)="next($event)"
    ></app-add-candidat-step>

  <!--
      <app-first-step-add-candidate
      *ngSwitchCase="2"
      [form]="firstStepForm"
      [loading]="loading"
      (formValid)="onFirstStepValid($event)"
    ></app-first-step-add-candidate>

    <app-second-step-add-candidate
      *ngSwitchCase="3"
      [form]="secondStepForm"
      [loading]="loading"
      (formValid)="onSecondStepValid($event)"
    ></app-second-step-add-candidate>

    <app-third-step-add-candidate
      *ngSwitchCase="4"
      [form]="thirdStepForm"
      [loading]="loading"
      (formValid)="onThirdStepValid($event)"
    ></app-third-step-add-candidate>

  -->  
  </ng-container>

  <!--
    <div *ngIf="step > 1" class="actions d-flex justify-content-between mt-4">
    <button mat-stroked-button (click)="back()" [disabled]="step === 1 || loading">
      Retour
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="next()"
      [disabled]="loading || isCurrentStepInvalid"
    >
      {{ step < 4 ? 'Suivant' : 'Terminer' }}
    </button>
  </div>
  -->
</div>
